import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { ICostUnitGroup } from '../../../../models/cost-unit-group.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICostUnitGroupState } from '../../../../services/facades/master-data/cost-unit-group-state.model';
import { CostUnitGroupFacade } from '../../../../services/facades/master-data/cost-unit-group.facade';
import { ICostUnitGroupDialogLayout } from '../../../../models/layout/cost-unit-group-dialog-layout.model';
import { CostUnitGroupLayoutService } from '../../../../services/layout/cost-unit-group-layout.service';

@Component({
    templateUrl: './cost-unit-group-dialog.component.html',
    styleUrls: [ './cost-unit-group-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostUnitGroupDialogComponent implements OnInit {
    public costUnitGroupState$: Observable<ICostUnitGroupState>;
    public formGroup$: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(null);
    public dialogFieldsValid: boolean = false;
    public layout: ICostUnitGroupDialogLayout;


    constructor(
        private myMatDialogRef: MatDialogRef<CostUnitGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostUnitGroup,
        private myCostUnitGroupFacade: CostUnitGroupFacade,
        private myCostUnitGroupLayoutService: CostUnitGroupLayoutService,
    ) {
    }

    public ngOnInit(): void {
        this.layout = this.myCostUnitGroupLayoutService.getCostUnitGroupDialogLayout();
        this.costUnitGroupState$ = this.myCostUnitGroupFacade.subState();
    }

    public async save(): Promise<void> {
        const data: ICostUnitGroup = this.formGroup$.value.getRawValue() as ICostUnitGroup;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostUnitGroupFacade.createCostUnitGroup(data);
        } else {
            data.id = this.data.id;
            await this.myCostUnitGroupFacade.updateCostUnitGroup(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    public formGroupChange(formGroup: FormGroup): void {
        this.formGroup$.next(formGroup);

        formGroup.valueChanges.subscribe((costUnit: ICostUnitGroup) => {
            this.validateDialogFields(costUnit);
        });
    }

    private validateDialogFields(costUnitGroup: ICostUnitGroup): void {
        // Validations to disable saving/editing
        if (!costUnitGroup.name) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
